import { createClient } from '@supabase/supabase-js'

export const supabase = createClient(
    'https://npbshnwpzucklggglbnw.supabase.co',
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5wYnNobndwenVja2xnZ2dsYm53Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTk2MTA5OTYsImV4cCI6MjAxNTE4Njk5Nn0.e1ZgLPsg-JSjEjBsZvxHhwraLVydYz0YHmx37TqztBQ'
)
